import { render, staticRenderFns } from "./carDetail.vue?vue&type=template&id=67b007a8&scoped=true"
import script from "./carDetail.vue?vue&type=script&lang=js"
export * from "./carDetail.vue?vue&type=script&lang=js"
import style0 from "./carDetail.vue?vue&type=style&index=0&id=67b007a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b007a8",
  null
  
)

export default component.exports